import { computed } from 'vue'
import { useContextStore } from 'src/store'
import type { ContextStore } from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/types'

type AgeGroup = {
  label: string
  frequency: number
  color: string
}

type PracticeByAge = ContextStore['context']['doctor_practice']['practice_by_ages'][number]

const AGE_GROUP_COLORS = ['#7aacf9', '#3981f1', '#1a5dd0'] as const

const AGE_GROUP_KEYS = {
  '0-17': '0-17 лет',
  '18-45': '18-45 лет',
  '46+': '46+ лет',
} as const

function getAgeUpperBound(ageLabel: string): number {
  const numbers = ageLabel.match(/\d+/g)

  if (!numbers?.length) {
    return 0
  }

  return Number(numbers[numbers.length - 1])
}

function getAgeGroupKey(ageLabel: string): keyof typeof AGE_GROUP_KEYS {
  const upperBound = getAgeUpperBound(ageLabel)

  if (upperBound <= 17) {
    return '0-17'
  }

  if (upperBound <= 45) {
    return '18-45'
  }

  return '46+'
}

export default function usePracticeAgeGroups() {
  const { context }: ContextStore = useContextStore()

  const ageGroups = computed<AgeGroup[]>(() => {
    const totals = {
      '0-17': 0,
      '18-45': 0,
      '46+': 0,
    }

    context.doctor_practice.practice_by_ages.forEach((item: PracticeByAge) => {
      totals[getAgeGroupKey(item.age)] += item.frequency
    })

    return (Object.keys(AGE_GROUP_KEYS) as Array<keyof typeof AGE_GROUP_KEYS>).map((key, index) => ({
      label: AGE_GROUP_KEYS[key],
      frequency: totals[key],
      color: AGE_GROUP_COLORS[index],
    }))
  })

  return {
    ageGroups,
  }
}
